import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  data: function data() {
    return {
      subscribed: [],
      uptodate: true
    };
  },
  computed: {
    feedsStore: function feedsStore() {
      return useFeedsStore();
    },
    rooms: function rooms() {
      return this.feedsStore.rooms;
    }
  },
  watch: {
    rooms: function rooms(newVal) {
      var _this = this;
      var unsubs = [];
      var subs = [];
      newVal.forEach(function (room) {
        if (!_this.subscribed.includes(room)) subs.push(room);
      });
      this.subscribed.forEach(function (room) {
        if (!newVal.includes(room)) unsubs.push(room);
      });
      this.subscribe(subs);
      this.subscribe(unsubs);
    }
  },
  mounted: function mounted() {
    this.$socket.on('feed-update', this.feedUpdate);
    this.$socket.on('feed-new', this.feedNew);
    this.$socket.on('connect', this.connected);
    this.$socket.on('disconnect', this.disconnected);
    this.subscribe(this.rooms);
  },
  methods: {
    feedUpdate: function feedUpdate(data) {
      this.feedsStore.updatePosts(data);
    },
    feedNew: function feedNew(data) {
      this.feedsStore.newPost(data);
    },
    subscribe: function subscribe(rooms) {
      var _this2 = this;
      rooms.forEach(function (room) {
        _this2.$socket.get('/user/subscribeRoom', {
          roomName: room
        }, function () {
          if (!_this2.subscribed.includes(room)) {
            _this2.subscribed.push(room);
          }
        });
      });
    },
    unsubscribe: function unsubscribe(rooms) {
      var _this3 = this;
      rooms.forEach(function (room) {
        _this3.$socket.get('/user/unsubscribeRoom', {
          roomName: room
        }, function () {
          var index = _this3.subscribed.indexOf(room);
          if (index >= 0) {
            _this3.subscribed.splice(index, 1);
          }
        });
      });
    },
    connected: function connected() {
      if (!this.uptodate) this.feedsStore.getNew();
      this.uptodate = true;
    },
    disconnected: function disconnected() {
      this.uptodate = false;
    }
  },
  destroyed: function destroyed() {
    this.$socket.off('feed-update', this.feedUpdate);
    this.$socket.off('feed-new', this.feedNew);
    this.$socket.off('connect', this.connected);
    this.$socket.off('disconnect', this.disconnected);
  }
};